<script>
  export default {
    name: 'navigation-item-arrow',

    props: {
      item: {
        type: Object,
        required: true
      },
      isOpen: {
        type: Boolean,
        required: true
      }
    }
  }
</script>

<template>
  <i v-if="item.children" class="menu-arrow" :class="{'open-arrow' : isOpen}">
    <font-awesome-icon :icon="['far', 'angle-right']"/>
  </i>
</template>
